.root {
	width: 34px;
	height: 18px;
	padding: 2px;
	box-sizing: border-box;
	display: inline-flex;
	align-items: center;
	flex: none;
	border: none;
	border-radius: 999px;
	background-color: var(--input-border);
	cursor: pointer;
	outline: none;
	transition: background-color 0.15s ease-in-out;
}

.root:focus-visible {
	box-shadow: 0 0 0 3px var(--color-primary-focus-ring);
}

.root[data-checked] {
	background-color: var(--alert-warning-border);
}

.root:disabled,
.root[data-disabled] {
	opacity: 0.5;
	cursor: not-allowed;
}

.thumb {
	width: 14px;
	height: 14px;
	border-radius: 50%;
	background-color: var(--input-bg);
	transition: transform 0.15s ease-in-out;
	transform: translateX(0);
}

.root[data-checked] .thumb {
	transform: translateX(16px);
}
